var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineDirectLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.95 21.59-11.59-6.1A3.93 3.93 0 0 1 2.25 12c0-1.47.81-2.81 2.11-3.49l11.59-6.1c1.55-.81 3.35-.55 4.6.67 1.25 1.22 1.55 3.02.77 4.58L19.7 10.9c-.34.68-.34 1.5 0 2.19l1.62 3.24c.78 1.56.48 3.36-.77 4.58-.77.76-1.74 1.15-2.74 1.15-.63 0-1.26-.15-1.86-.47zm.7-17.85L5.06 9.84c-.82.43-1.31 1.24-1.31 2.16 0 .92.49 1.73 1.31 2.16l11.59 6.1c1.16.61 2.24.19 2.85-.42.62-.6 1.06-1.67.48-2.84l-1.62-3.24a3.982 3.982 0 0 1 0-3.53l1.62-3.24c.59-1.17.14-2.24-.48-2.84-.4-.39-1-.71-1.7-.71-.36 0-.75.09-1.15.3z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineDirectLeft);
export default __webpack_public_path__ + "static/media/vuesax-outline-direct-left.cae2a99611c4fc1f2853027696230275.svg";
export { ForwardRef as ReactComponent };